import DefaultApiService from "./default";

const baseBySource = (source) =>
  source === "Management"
    ? "SLN/Management/ProjectWorkflowFoundation"
    : "SLN/SolarentOperator/ProjectWorkflowFoundation";

const unwrapPayload = (res) => res?.data ?? res ?? null;

const ProjectExecutionActivationApi = {
  getReadyForExecutionActivations: async (source) => {
    const res = await DefaultApiService.getCustomeApi(
      `${baseBySource(source)}/GetReadyForExecutionActivations`
    );
    return {
      ok: res?.isSuccess !== false,
      message: res?.message || "",
      data: unwrapPayload(res) || [],
    };
  },

  getExecutionActivation: async (source, { requestId, projectContractId } = {}) => {
    const params = new URLSearchParams();
    if (requestId) params.set("requestId", String(requestId));
    if (projectContractId) params.set("projectContractId", String(projectContractId));
    const res = await DefaultApiService.getCustomeApi(
      `${baseBySource(source)}/GetExecutionActivation?${params.toString()}`
    );
    return {
      ok: res?.isSuccess !== false,
      message: res?.message || "",
      data: unwrapPayload(res),
    };
  },

  activateProjectExecution: async (source, payload) => {
    const res = await DefaultApiService.postApi(
      `${baseBySource(source)}/ActivateProjectExecution`,
      payload
    );
    return {
      ok: res?.isSuccess !== false,
      message: res?.message || "",
      data: unwrapPayload(res),
    };
  },

  suspendActivation: async (source, payload) => {
    const res = await DefaultApiService.postApi(
      `${baseBySource(source)}/SuspendActivation`,
      payload
    );
    return {
      ok: res?.isSuccess !== false,
      message: res?.message || "",
      data: unwrapPayload(res),
    };
  },

  cancelActivation: async (source, payload) => {
    const res = await DefaultApiService.postApi(
      `${baseBySource(source)}/CancelActivation`,
      payload
    );
    return {
      ok: res?.isSuccess !== false,
      message: res?.message || "",
      data: unwrapPayload(res),
    };
  },
};

export default ProjectExecutionActivationApi;
